
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'


export default {
components: {
Grid,
GridItem
},
data () {
return {
user: {

type: 0,
title: '',
avatar: '',
company_id: 0,
company: '',

mobile: '',

superior_id: 0,
superior: '',
invite_me: 0
}
}
},
beforeRouteEnter (to, from, next) {
next((vm) => {
vm.user = vm.$store.state.oice.user || vm.user
})
},
methods: {
login () {
this.$checkAuth()
}
}
}



// WEBPACK FOOTER //
// ./src/pages/index/views/My/Index.vue